import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { HttpService } from '../../service/services/http.service';
import { StorageSessionService } from '../../storage/services/storage.session.service';
import { AnalyticsCoreURLService } from '../../../reporting/analytics-core/services/analytics-core.url.service';
import { HttpClient } from '@angular/common/http';
import { AnalyticsMixpanelService } from '../../../../app/reporting/analytics/services/analytics.mixpanel.service';

@Injectable()
export class LoginService extends HttpService {
	private domainName: string;

	constructor(
		http: HttpClient,
		storageSessionService: StorageSessionService,
		router: Router,
		private analyticsCoreURLService: AnalyticsCoreURLService,
		protected analyticsMixpanelService: AnalyticsMixpanelService
	) {
		super(http, storageSessionService, router);
	}

	login(loginModel: any) {
		loginModel.domain = this.analyticsCoreURLService.domainName;
		return this.post(this.analyticsCoreURLService.serviceURL + '/analytics_module/api_login', loginModel).pipe(
			map((res) => {
				if (res['success']) {
					this.analyticsMixpanelService.userLoginTrack(res);
				}
				return res;
			}),
			catchError((error) => this.handleError(error))
		);
	}

	getPartnerCname(cnameMappingModel: any) {
		cnameMappingModel.domain = this.analyticsCoreURLService.domainName;
		return this.post(
			this.analyticsCoreURLService.serviceURL + '/analytics_module/get_partner_cname_mapping',
			cnameMappingModel
		).pipe(
			map((res) => res),
			catchError((error) => this.handleError(error))
		);
	}

	resetPassword(passwordModel: any) {
		passwordModel.domain = this.analyticsCoreURLService.domainName;
		return this.post(this.analyticsCoreURLService.serviceURL + '/analytics_module/forgot_password', passwordModel).pipe(
			map((res) => res),
			catchError((error) => this.handleError(error))
		);
	}

	changePassword(details) {
		const reqBody = details;
		reqBody['domain'] = this.analyticsCoreURLService.domainName;
		return this.post(this.analyticsCoreURLService.serviceURL + '/analytics_module/reset_password', reqBody).pipe(
			map((res) => res),
			catchError((error) => this.handleError(error))
		);
	}

	validateApiLoginUserid(loginModel: any) {
		loginModel.domain = this.analyticsCoreURLService.domainName;
		return this.post(
			this.analyticsCoreURLService.serviceURL + '/analytics_module/validate_api_login_userid',
			loginModel
		).pipe(
			map((res) => res),
			catchError((error) => this.handleError(error))
		);
	}

	getHostname() {
		return this.analyticsCoreURLService.domainName;
	}

	isSSOEnabledFlow(loginModel: any) {
		return this.post(this.analyticsCoreURLService.serviceURL + '/analytics_module/is_sso_flow', loginModel).pipe(
			map((res) => res),
			catchError((error) => this.handleError(error))
		);
	}
}
